import "./App.css";
import Map from "./components/Map";

function App() {
  return (
    <div className="map-container">
      <Map />
    </div>
  );
}

export default App;
